// Generated by CoffeeScript 1.6.2
(function() {
  var asciiJSON;

  asciiJSON = exports;

  asciiJSON.isAscii = function(text) {
    return /^[\x00-\x7F]*$/.test(text);
  };

  asciiJSON.escapeNonAsciis = function(text) {
    var chars, code, i;

    chars = [];
    i = 0;
    while (i < text.length) {
      code = text.charCodeAt(i);
      if (code < 128) {
        chars.push(text[i]);
      } else {
        if (code < 256) {
          chars.push('\\u00');
        } else if (code < 4096) {
          chars.push('\\u0');
        } else {
          chars.push('\\u');
        }
        chars.push(code.toString(16));
      }
      i++;
    }
    return chars.join('');
  };

  asciiJSON.stringify = function(object) {
    var utf8JSON;

    utf8JSON = JSON.stringify(object);
    return asciiJSON.escapeNonAsciis(utf8JSON);
  };

  asciiJSON.parse = JSON.parse;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/ascii-json/lib/ascii-json.js
// module id = 361
// module chunks = 0